import axiosInstance from "../../../helpers/api";

export const getAllSystemGroups = (body) => {
  return axiosInstance.get("/superadmin/student-groups/all", body);
};

export const getAllGroups = (body) => {
  return axiosInstance.get("/superadmin/student-groups", body);
};

export const getPerformanceGroups = (body) => {
  return axiosInstance.get("/admin/performance_groups", body);
};

export const editGroups = (formData) => {
  return axiosInstance.post(
    `/superadmin/student-groups/${formData.id}`,
    formData.formData
  );
};

export const createGroups = (formData) => {
  return axiosInstance.post("/superadmin/student-groups", formData);
};

export const deleteGroup = (id) => {
  return axiosInstance.delete(`/superadmin/student-groups/${id}`);
};

export const getCourseGroup = (id) => {
  return axiosInstance.get(`/superadmin/student-groups/courses/${id}`);
};
